import axios from './config';
import Auth from '../auth';
import Util from '../util';
import Global from '../global';
import Logger from '../logger';
import { sha256 } from 'js-sha256';
import {Constants} from "../../src";
axios.refreshToken = function (resolve, reject, config, customize, responseState) {
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  let refreshConfig = {
    url: Global.getRefreshTokenUrl(),
    method: 'post',
    headers: headers,
    data: {
      refreshToken: Auth.getRefreshToken()
    }
  };
  refreshConfig.transformRequest = [function (data) {
    let ret = '';
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
    }
    return ret;
  }];
  if(!this.refreshing){
    this.refreshing = true;
    let startTime = Date.now(); // 请求开始时间
    axios(refreshConfig).then(response => {
      // 记录 api 日志
      let endTime = Date.now(); // 请求结束时间
      let time = (endTime - startTime) / 1000; // 消耗时长，单位：秒
      let logData = {
        type: 'api',
        api: {
          url: refreshConfig.url,
          time,
          status: response.data.status,
          code: Util.isEmpty(response.data.code) ? '' : response.data.code,
          message: response.data.message || '',
          moreInfo: {
            request: {
              refreshToken: Auth.getRefreshToken()
            },
            response: response
          }
        }
      }
      Logger.addLog(logData);

      this.refreshing = false;
      // 请求接口正确且成功时
      if (response.data.status === 200) {
        let result = !Util.isNull(response.data.result) ? response.data.result : response.data;
        if (result.jwt_token) {
          Auth.setJwtToken(result.jwt_token);
        }
        if (result && result.refresh_token) {
          Auth.setRefreshToken(result.refresh_token);
        }
        if(resolve){
          this.httpRequest(resolve, reject, config, true, customize, responseState);
        }
      } else if(!Global.isSkipLogin() && resolve){
        this.signout(refreshConfig);
      } else if(resolve){
        resolve(response.data);
      }
    }).catch(error => {
      // 记录 api 日志
      let endTime = Date.now(); // 请求结束时间
      let time = (endTime - startTime) / 1000; // 消耗时长，单位：秒

      // 获取 status code
      let message = error.toString();
      let reg = /code \d{3}/;
      let status = 0;
      let matchRes = message.match(reg);
      if (matchRes.length > 0) {
        status = parseInt(matchRes[0].split(' ')[1]);
      }

      let logData = {
        type: 'api',
        api: {
          url: refreshConfig.url,
          time,
          status,
          message,
          moreInfo: {
            request: {
              refreshToken: Auth.getRefreshToken()
            },
            error: error
          }
        }
      }
      Logger.addLog(logData);

      this.refreshing = false;
      console.error('refreshToken,', error);
      if(!Global.isSkipLogin() && resolve){
        this.signout(refreshConfig);
      } else if(resolve){
        resolve(error);
      }
    });
  } else {
      setTimeout(()=>{
        this.httpRequest(resolve, reject, config, true, customize, responseState);
      }, 3000);
  }
};
axios.httpRequest = function (resolve, reject, config, isRetry, customize, responseState) {
  if(Auth.getJwtToken() && isRetry){
    config.headers['jwt-token'] = Auth.getJwtToken();
  }
  if(!customize){
    customize = {};
  }
  let isDisableRefreshToken = Global.isDisableRefreshToken();
  if(!Util.isEmpty(customize['disableRefreshToken'])){
    isDisableRefreshToken = customize['disableRefreshToken'];
  }
  if(Global.isSkipLogin()){
    isDisableRefreshToken = true;
  }
  if(!Util.isEmpty(customize['withCredentials'])){
    config['withCredentials'] = customize['withCredentials'];
  }
  if(customize.headers){
			for(let key in customize.headers){
				config.headers[key] = customize.headers[key];
        if(customize.headers[key] == null || customize.headers[key] == ''){
          delete config.headers[key];
        }
			}
	}
  let startTime = Date.now(); // 请求开始时间
  axios(config)
    .then(response => {
      // 记录 api 日志
      let endTime = Date.now(); // 请求结束时间
      let time = (endTime - startTime) / 1000; // 消耗时长，单位：秒
      let logData = {
        type: 'api',
        api: {
          url: config.url,
          time,
          status: response.data.status,
          code: Util.isEmpty(response.data.code) ? '' : response.data.code,
          message: response.data.message || '',
          moreInfo: {
            request: {
              jwtToken: Auth.getJwtToken()
            }
          }
        }
      }
      Logger.addLog(logData);

      // 请求接口正确且成功时
      if (response.data.status === 200) {
        sessionStorage.setItem('REFRESH_TOKEN_COUNT', 0);
        if(responseState === 0){
          resolve(response.data);
        } else {
          resolve(!Util.isNull(response.data.result) ? response.data.result : response.data);
        }
      } else if (this.isInvalidToken(response, config)) {
        let count = sessionStorage.getItem('REFRESH_TOKEN_COUNT') || 0;
        if (!isDisableRefreshToken && count <= 10) { // jwtoken 过期只retry有10次失败的机会
          sessionStorage.setItem('REFRESH_TOKEN_COUNT', ++count);
          this.refreshToken(resolve, reject, config, customize, responseState);
        } else {
          if(Global.isSkipLogin()){
            if(responseState === 0){
              resolve(response.data);
            } else {
              resolve(!Util.isNull(response.data.result) ? response.data.result : response.data);
            }
          } else {
            this.signout(config);
          }
        }
      } else {
        // 请求接口错误或不成功时
        if(responseState === 0){
          resolve(response.data);
        } else {
          resolve(!Util.isNull(response.data.result) ? response.data.result : response.data);
        }
      }
    }).catch(error => {
      // 记录 api 日志
      let endTime = Date.now(); // 请求结束时间
      let time = (endTime - startTime) / 1000; // 消耗时长，单位：秒

      // 获取 status code
      let message = error.toString();
      let reg = /code \d{3}/;
      let status = 0;
      let matchRes = message.match(reg);
      if (matchRes && matchRes.length > 0) {
        status = parseInt(matchRes[0].split(' ')[1]);
      }

      let logData = {
        type: 'api',
        api: {
          url: config.url,
          time,
          status,
          message,
          moreInfo: {
            request: {
              jwtToken: Auth.getJwtToken()
            },
            error: error
          }
        }
      }
      Logger.addLog(logData);

    if(!this.erroring){
      Util.errorMessage('网络异常, 请求失败~~~', config);
      this.erroring = true;
      setTimeout(() => {
        this.erroring = false;
      }, 10000);
    }
      reject(error);
  });
};

axios.ajax = function (url, method, params, form = false, customize = {}, responseState = 1) { // responseState = 0 response.data else response.data.result
  return new Promise((resolve, reject) => {
    let config = null;
    if(url && (url.toLowerCase().indexOf('http://') !== 0 && url.toLowerCase().indexOf('https://') !== 0)){
      if(Global.getCustomConfig()['KIAF_HOST_URL']){
        url = Global.getHostUrl() + url;
      } else {
        url = Global.getBaseUrl() + url;
      }
    }
    if (form) {
      config = {
        url: url,
        method: method,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      if(Global.isSha256()){
        if(params.password){
          config.headers = Object.assign(config.headers, {'Content-SHA-256': true});
          params.password = sha256(params.password);
        }
      }

      config.transformRequest = [
        function (data) {
          let ret = '';
          for (let it in data) {
            ret +=
              encodeURIComponent(it) +
              '=' +
              encodeURIComponent(data[it]) +
              '&';
          }
          return ret;
        }
      ];
    } else {
      config = {
        url: url,
        method: method
      };
      config.headers = {
        'Content-type': 'application/json;charset=utf-8'
      };
      if (Auth.getJwtToken()) {
        config.headers['jwt-token'] = Auth.getJwtToken();
      }
    }

    // 若当前项目是多租户模式，需要在 header 里面添加上 tenantid 这个参数
    if (Global.getCustomConfig()['RBAC_MULTI_TENANT'] == 'Y') {
      // 从 userInfo 中获取 tenantid
      let userInfo = Auth.getUserInfo();
      if (userInfo && userInfo.user && userInfo.user.tenantId) {
        config.headers.tenantid = userInfo.user.tenantId;
      }
    }

    if (method && method.toLowerCase() === 'get') {
      config.params = params;
    } else {
      config.data = params;
    }
    this.httpRequest(resolve, reject, config, false, customize, responseState);
  });
};

axios.ajax0 = function (url, method, params, form = false, customize) { // responseState = 0 response.data else response.data.result
  return this.ajax(url, method, params, form, customize, 0);
};

axios.signout = function(config = {}) {
  let redirectUrl = Auth.getRedirectUrl();
  sessionStorage.setItem(Constants.STORAGE_KEY_REDIRECT_URL + '_' + Auth.getUserInfo().username, redirectUrl);
  Auth.exit();
};

axios.isInvalidToken = function (response, config ={}) {
  if(config.url && config.url.indexOf('/auth/logout') > 0){
    return false;
  }if((response.data.status === 10014 || response.data.status === 10013) && response.data.code == '-1') { // 10013 错误的JWT 10014 jwt过期 10015 JWT为空
		return true;
	} else if(response.data.status === 401 || response.data.code === 401){
    return true;
	} else if(response.data.code == '-1' && (response.data.message === 'Invalid token' || response.data.message === 'token已失效')){
    return true;
  } else if(response.data.code == '-1' && response.data.message === '用户jwt签名错误'){
    return true;
  } else {
		return false;
	}
};
// 登录的时候要form表单提交请求中多了form参数，关于权限的要请求权限的服务器地址多了authorityService参数
export default axios;
